import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import CTAButton from "./CTAButton";

const featured = "Lavoro preciso, casa lasciata pulita e tempi rispettati. Daniele è stato disponibile fino alla fine.";

const reviews = [
  "Puntuali e ordinati. Smaltimento incluso: zero pensieri.",
  "Infissi su misura perfetti, finiture curate.",
  "Disponibili anche dopo il lavoro per le regolazioni.",
  "Lavoro in ferro robusto e ben rifinito.",
  "Preventivo chiaro e tempi rispettati.",
  "Consigli onesti: ci hanno detto cosa conviene davvero fare.",
];

const ReviewsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} className="bg-background py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground">
            Recensioni
          </h2>
          <p className="mt-4 text-muted-foreground font-body">
            Puntualità, pulizia e disponibilità: sono le cose che i clienti citano più spesso.
          </p>
        </motion.div>

        {/* Featured review */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="border border-border rounded-sm p-8 md:p-12 mb-8"
        >
          <p className="font-body text-lg md:text-xl text-foreground/90 leading-relaxed italic">
            "{featured}"
          </p>
          <div className="mt-4 flex gap-1">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="text-accent">★</span>
            ))}
          </div>
        </motion.div>

        {/* Review grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {reviews.map((review, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 + i * 0.1 }}
              className="border border-border/50 rounded-sm p-6 hover:border-accent/30 transition-colors duration-500"
            >
              <p className="font-body text-sm text-foreground/70 leading-relaxed">"{review}"</p>
              <div className="mt-3 flex gap-1">
                {[...Array(5)].map((_, j) => (
                  <span key={j} className="text-accent text-xs">★</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 1 }}
          className="mt-12"
        >
          <CTAButton className="cta-button hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
        </motion.div>
      </div>
    </section>
  );
};

export default ReviewsSection;